import { render } from "./expertise-card.vue?vue&type=template&id=f19764dc&scoped=true"
import script from "./expertise-card.vue?vue&type=script&lang=js"
export * from "./expertise-card.vue?vue&type=script&lang=js"

import "./expertise-card.vue?vue&type=style&index=0&id=f19764dc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f19764dc"]])

export default __exports__